import styled, { css } from 'styled-components';
import Popover from 'components/Popover';
import { DisplayModeType, theme, TOPHEADER_ZINDEX } from 'styles';
import { Flex, Layout } from 'UI';

const { Header } = Layout;

export const PageHeaderDiv = styled.div<{ height: number; displayMode: DisplayModeType }>`
  display: flex;
  flex-wrap: nowrap;
  height: ${({ height }) => `${height}px`};
  width: 100%;
  background-color: ${({ displayMode }) => theme.displayMode[displayMode].brandColor};
  color: ${theme.color.white};
`;

export const AntHeader = styled(Header)<{ height: number }>`
  height: ${({ height }) => `${height}px`};
  position: sticky;
  top: 0;
  z-index: ${TOPHEADER_ZINDEX};
`;

export const SMenuItem = styled(Flex)`
  cursor: pointer;
  border-radius: 8px;
  margin: 0 16px;
  padding: 0 16px;

  :hover {
    background-color: ${theme.color.grey95};
  }
`;

export const MenuItemDivider = styled.div`
  position: relative;

  ::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 15%;
    width: 70%;
    border-bottom: 1px solid ${theme.color.grey90};
  }

  :last-child::after {
    border-bottom: none;
  }
`;

export const SPopover = styled(Popover)`
  .ant-popover-arrow {
    right: 5px;
  }

  .ant-popover-arrow-content,
  .ant-popover-arrow-content::before {
    background: ${theme.color.white};
  }

  position: fixed;
`;

const dropdownStyle = css`
  border: solid 1px ${theme.color.grey85};
  padding: 0 8px 0 8px;
  max-height: 36px;
`;

export const SectionWrapper = styled(Flex)<{ pointer?: boolean; dropDownInputs: boolean }>`
  ${({ pointer }) => (pointer ? 'cursor: pointer;' : 'cursor: default')};
  border-radius: 4px;

  ${({ dropDownInputs }) => dropDownInputs && dropdownStyle}
  :hover {
    background-color: ${({ pointer }) => pointer && theme.color.grey95};
  }
`;

export const Sdiv = styled.div<{ isHovered: boolean }>`
  background-color: ${({ isHovered }) => (isHovered ? theme.color.grey10 : null)};
`;

export const ExitConnectAsWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 24px;
`;
